import { render, staticRenderFns } from "./ActionLogs.vue?vue&type=template&id=32cbcb3f&scoped=true&"
import script from "./ActionLogs.vue?vue&type=script&lang=js&"
export * from "./ActionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbcb3f",
  null
  
)

export default component.exports